function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#9DF3F0",
  d: "M27.518 48.658c3.906-1.097 7.324-3.615 11.113-5.216 2.161-.913 4.276-.816 6.004-.067.434-.368.868-.735 1.271-1.14 5.004-4.104 7.285-10.776 5.755-17.859-.018-.084-.044-.166-.063-.25-.791-6.373-4.004-12.646-9.613-15.929a16.538 16.538 0 00-2.42-1.144c-1.956-1.292-4.059-2.316-6.25-2.988-9.606-2.942-20.692 1.042-25.678 9.905-4.903 8.717-3.571 20.267 3.556 27.379 4.546 4.538 10.442 6.903 16.325 7.309z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0DFE6",
  d: "M38.632 43.442c-3.789 1.601-7.207 4.118-11.113 5.216-1.131.318-2.297.534-3.532.552-1.324.02-15.052-2.554-13.346-5.827.533-1.022-.634-2.533-1.73-1.731-7.438 5.444-.818 12.711 5.158 16.719 9.973 6.69 24.839 4.694 32.7-4.386 3.596-4.153 1.671-8.962-2.132-10.611-1.729-.748-3.844-.845-6.005.068z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#525D7D",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M51.5 23.833c0 13.531-9.969 25.5-23.5 25.5s-24.5-9.969-24.5-23.5 9.969-22.5 23.5-22.5 24.5 6.969 24.5 20.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#525D7D",
  d: "M35.607 31.319c0-5.512-5.301-5.857-8.148-6.043-3.752-.245-3.752-.587-3.752-1.336 0-2.326 3.435-3.373 5.875-3.373.556 0 1.088.047 1.582.14a2.286 2.286 0 002.671-1.827 2.286 2.286 0 00-1.826-2.672 13.255 13.255 0 00-2.427-.218c-.602 0-1.204.045-1.799.118-.154-1.151-.321-2.324-.585-3.493a2.262 2.262 0 00-.922-1.347 2.266 2.266 0 00-1.815-.382c-.421.095-.759.327-1.049.607-.559.537-.86 1.319-.678 2.13.262 1.161.422 2.376.594 3.661l.028.199c-2.463 1.31-4.225 3.458-4.225 6.457 0 5.38 5.225 5.721 8.03 5.903 3.62.236 3.855.587 3.871 1.32-.523.693-3.118 1.721-4.807 1.721-1.243 0-2.364-.359-3.336-1.065a2.29 2.29 0 00-2.691 3.703c1.626 1.181 3.551 1.819 5.582 1.904.174.774.328 1.46.503 2.133a2.287 2.287 0 104.43-1.149c-.146-.565-.272-1.138-.401-1.709 2.645-.893 5.295-2.614 5.295-5.382z"
});

var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55.333,
    height: 64,
    viewBox: "0 0 55.333 64"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCoin;